import React from 'react'
import {Box, Button, Grid} from "@material-ui/core";
import PropTypes from "prop-types";
import style from './twobuttoncontainer.module.css'
import {CANCEL, SUBMIT} from "../../constants/appconstants";
function TwoButtonContainer(props){
    console.log(props)
    return (
        <Grid container justify={"center"} className={style.two_button_container_wrapper}>
            <Grid item lg={6}>
                <Button
                    variant="contained"
                    className={style.two_button_container_clear_button}
                    onClick={props.onCloseRequestHandler}
                >
                    {CANCEL}
                </Button>
            </Grid>
            <Box minWidth={"20px"}/>
            <Grid item lg={6}>
                <Button
                    variant="contained"
                    type={"submit"}
                    onClick={props.onSubmitRequestHandler || null}
                    className={style.two_button_container_submit_button}
                >
                    {SUBMIT}
                </Button>
            </Grid>
        </Grid>
    )
}
TwoButtonContainer.propTypes = {
    onCloseRequestHandler:PropTypes.func.isRequired,
    onSubmitRequestHandler:PropTypes.func
}

export default TwoButtonContainer
